<script setup lang="ts">
import { computed } from 'vue';
import type { CardHeaderProps, NormalizedCardProps } from './card.types';
import { useSharedState } from 'composables/useSharedState';
import { useComponentContext } from 'composables/useComponentContext';
import { useStateStore } from 'composables/useStateStore';
import {
  cardHeaderClasses,
  cardHeaderDescriptionClasses,
  cardHeaderHeadingClasses
} from './card.styles';

const props = defineProps<CardHeaderProps>();

useSharedState(props);

const context = useComponentContext();
const stateStore = useStateStore<NormalizedCardProps>();

const cardState = computed(() => {
  if (!context.uid) return null;
  return stateStore.findParentOfType(context.uid, 'Card');
});

const cardProps = computed(() => {
  return cardState.value?.props as NormalizedCardProps | undefined;
});

const headingProps = computed(() => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { description, color, ...heading } = props;
  return heading;
});
</script>

<template>
  <header :class="cardHeaderClasses(cardProps)">
    <slot>
      <e-heading
        v-bind="headingProps"
        :class="cardHeaderHeadingClasses(cardProps)"
      ></e-heading>
      <p
        v-if="description"
        :class="cardHeaderDescriptionClasses(cardProps)"
      >
        {{ description }}
      </p>
    </slot>
  </header>
</template>
